import axiosInstance from './axiosInstance'

export interface CalendarUser {
  id: string
  name: string
  email: string
}

export interface UnifiedCalendarEvent {
  id: string
  title: string
  eventType: 'FOLLOW_UP' | 'TASK'
  category: 'CALL' | 'MEETING' | 'DEMO' | 'SITE_VISIT' | 'TASK' | 'OTHER' | string
  source: 'LEAD' | 'DEAL' | 'SALES' | 'RETENTION'
  sourceId: string
  sourceName: string | null
  scheduledAt: string
  endTime: string | null
  status: string
  priority: string | null
  notes: string | null
  outcome: string | null
  reminderMinutes: number | null
  assignedTo: CalendarUser | null
  createdBy: CalendarUser | null
  createdAt: string
  updatedAt: string
}

export interface GetCalendarEventsParams {
  fromDate?: string
  toDate?: string
  orgIds?: string[]
  lobIds?: string[]
}

export const calendarApi = {
  getEvents: async (params?: GetCalendarEventsParams): Promise<UnifiedCalendarEvent[]> => {
    const res = await axiosInstance.get<{ data: UnifiedCalendarEvent[] }>('/calendar/events', { params })
    return res.data.data ?? []
  },
}
